import { Injectable } from "@angular/core";

import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { UserPagePermissionModel } from '../models/UserPagePermission';
import { RoleMangementApi } from '../api.url';
import { ApiResponse } from "../models/api.response";
import { AppConfig } from "../../app.config";
import { Router } from '@angular/router';
import { environment } from "environments/environment";
import { FuseAlertService } from '@fuse/components/alert';
import * as signalR from '@microsoft/signalr';
import { Subject } from "@microsoft/signalr";
import { NotificationService } from "./notification.service";
import { GlobalCompanyService } from "../component/global-company/global-company.service";

@Injectable()
export class HasPermissionService {
  apiUrl = environment.apiBaseUrl
  public currUserPermissions: UserPagePermissionModel[] = [];
  public isApiCallCompleted: boolean = false;
    private unsubscribeAll: Subject<any>;
    private hubConnection: signalR.HubConnection;

  notificationService: NotificationService;
  constructor(private http: HttpClient, private router: Router, private readonly appConfig: AppConfig,public fuseAlertService: FuseAlertService,private globalCompanyService: GlobalCompanyService) {
    this.globalCompanyService.expireSubscription.subscribe(res => {
      if (res === true) {
        this.globalCompanyService.startSubscriptionExpirationTimer();
      } else {
        this.globalCompanyService.closeNotificaction();
      }
    });
  }

  public getCurrUserPermissions(): any {
    return this.currUserPermissions;
  }

  public setCurrUserPermissions(permissions: any): void {
    this.currUserPermissions = permissions;
    var editPolicyObj = new UserPagePermissionModel();
    editPolicyObj.pageId = 0;
    editPolicyObj.menuId = "0";
    editPolicyObj.permissionId = 0;
    editPolicyObj.menuName = "";
    editPolicyObj.permissionName = "";
    editPolicyObj.pageName = "";
    editPolicyObj.pageUrl = "main/policyselection/edit";
    this.currUserPermissions.push(editPolicyObj);
    var questionflag = this.hasPermission("policyselection", "question");
    if (questionflag)
      this.addQuestionAddAndEditPermission();
  }

  public hasPermission(pageName: string, actionName: string): boolean {
    try {
      for (let x of this.currUserPermissions) {
        if (x.pageName.toLocaleLowerCase() === pageName && x.permissionName.toLocaleLowerCase() === actionName) {
          return true;
        }
      }
    }
    catch (ex) {
    }
    return false;
  }

  getUserPermission(): Observable<ApiResponse> {
    return this.http.get<ApiResponse>(this.apiUrl +RoleMangementApi.GetPermissionForLoggedInUser);
    
  }

  
  

  getUserPermissionObservable(url, fromGuard: boolean = false) {

    return this.http.get<ApiResponse>(this.apiUrl + RoleMangementApi.GetPermissionForLoggedInUser).pipe(
      map((res) => {
        if (res.status === 1) {
          //this.fuseAlertService.show(res.message, res.status);
          this.setCurrUserPermissions(res.data);
          this.isApiCallCompleted = true;
          var objHasPermission = this.isPermission(url, fromGuard);
          if (objHasPermission) {
            return true;
          } else {
            this.router.navigate(['/errors/error-forbidden']);
            return false;
          }
        } else {
          this.router.navigate(['/errors/error-forbidden']);
          return false;
        }
      }));

  }

  isChildrenPermission(children: any): boolean {


    var isChildPermission = false;
    var innerChildPermission = true;
    if (children) {
      for (let i = 0; i < children.length; i++) {
        if (children[i].children && children[i].children.length > 0) {
          let innerChild = children[i].children;
          for (let i = 0; i < innerChild.length; i++) {
            var innerChildPermission = this.isPermission(innerChild[i].url);
            if (innerChildPermission) break;
          }
        }
        if (!innerChildPermission) break;
        isChildPermission = this.isPermission(children[i].url);
        if (isChildPermission) break;
      }
    }
    return isChildPermission;
  }

  isPermission(pageUrl: any, fromGuard: boolean = false): boolean {
    if (!pageUrl || pageUrl === "pages")
      return true;
    var urlLastCharacter = pageUrl.charAt(pageUrl.length - 1);
    if (urlLastCharacter === '/') {
      pageUrl = pageUrl + "list";
    }
    if (this.currUserPermissions != null && this.currUserPermissions.length > 0) {
      var filter = this.currUserPermissions.find(m => m.pageUrl === pageUrl);
      if (!filter) {

        /**
         * If method is call from navigation menu and Page Url is client user and
         * don't have permission for Assessment dashboard return true else false n*
         */
        
        if (!fromGuard && pageUrl.includes("main/dashboard/client-user")) {
          var isDashboardAppended = this.currUserPermissions.find(m => m.pageUrl === 'main/dashboard/all');
          if (!isDashboardAppended) return true;
          else return false;
        }
        else return false;
      }
      else return true;
    }
    return false;

  }

  addQuestionAddAndEditPermission() {
    var addUrl = "main/policyselection/question/add";
    var editUrl = "main/policyselection/question/edit";
 
      var addObj = new UserPagePermissionModel();
      addObj.pageId = 0;
      addObj.menuId = "0";
      addObj.permissionId = 0;
      addObj.menuName = "";
      addObj.permissionName = "";
      addObj.pageName = "";
    addObj.pageUrl = addUrl;
    this.currUserPermissions.push(addObj);

    var editObj = new UserPagePermissionModel();
    editObj.pageId = 0;
    editObj.menuId = "0";
    editObj.permissionId = 0;
    editObj.menuName = "";
    editObj.permissionName = "";
    editObj.pageName = "";
    editObj.pageUrl = editUrl;
    this.currUserPermissions.push(editObj);
  
  }

}
